import React from "react";
import classNames from "classnames";
import { useLocation } from "react-router";
import styles from "./JobDetail.module.css";
import arrow from "../../Img/jobDetail/arrow.png";
import { Link } from "react-router-dom";
import darkArrow from "../../Img/jobDetail/dark_arrow.png";
import filterImg from "../../Img/jobPage/filter.png";
import { list } from "../../common/jobList/jobList.js";
import getGA from "../../service/ga.js";
import { useEffect } from "react";
const JobDetail = ({ isDarkMode }) => {
  const location = useLocation();
  let job = list.find(
    (data) => Number(location.pathname.split("/")[2]) === data.id
  );

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <div className={styles.topBackground}>
          <img
            src={job.img}
            alt=""
            className={
              job.position === "개발" ? styles.selectImg : styles.defaultImg
            }
          />
          <img
            src={filterImg}
            alt=""
            className={
              job.position === "개발" ? styles.selectImg : styles.defaultImg
            }
          />
          <div className={styles.duty}>
            {job?.team}
            <br />
            {job?.duty}
          </div>
          <div className={styles.type}>{job?.type}</div>
          <Link to="/position/apply" state={{ data: job }}>
            <button className={styles.topApplyBtn}>
              {job?.lo === "en" ? "Apply now" : "지원하기"}
            </button>
          </Link>
        </div>
      </div>

      <>
        <div
          className={classNames(
            !isDarkMode ? styles.contextContainer : styles.dark_contextContainer
          )}
        >
          {job?.position === "경영지원" && job?.sort === "HR" ? (
            <>
              <div>
                <div>MondayOFF HR팀은 </div>회사의 비전과 조직 문화에 맞는
                인재를 채용하고, 인사 제도의 기획 및 운영을 통해 회사의 성장을
                전폭적으로 서포트하는 팀입니다. MondayOFF는 2018년에 설립하여,
                급속도로 성장하고 있는 모바일 게임 개발/퍼블리싱 스타트업
                입니다. HR팀은 앞으로 더 큰 폭의 성장을 위해 회사의 필요한
                인력풀을 캐치하여 채용하고, 신규 입사자의 빠른 적응을 위해
                맞춤형 온보딩 프로그램을 진행합니다. 또한 인재가 조직에서 최고의
                역량을 발휘할 수 있도록 조직 문화 및 인사 체계를 만들어 갈
                분들을 기다리고 있습니다.
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "경영지원" && job?.sort === "Money" ? (
            <>
              <div>
                <div>MondayOFF 경영지원팀은 </div>회사가 더욱 안정적으로 성장할
                수 있도록 경영 업무들을 지원해주는 팀입니다. MondayOFF는
                2018년에 설립하여, 급속도로 성장하고 있는 모바일 게임
                개발/퍼블리싱 스타트업 입니다. 회사의 운용 자금이 점점 커지고
                있는 환경에서, 경영지원팀의 회계부서에서는 투명한 장부관리와
                분기별 부가세 신고, 기말 회계감사 지원 등 회사의 전반적인 회계
                업무를 진행합니다.
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "개발" && job?.sort === "Game" ? (
            <>
              <div>
                <div>MondayOFF 하이퍼 캐주얼 스튜디오 팀은 </div>누구나 즐길 수
                있는 간단한 게임을 제작하여 MondayOFF 사업 최전방에서 활약하는
                팀입니다. MondayOFF는 국내 최고의 하이퍼 캐주얼 게임 개발사로서
                게임의 제작에 관한 많은 노하우를 가지고 있습니다. 이런 환경에서
                스튜디오 팀은 평균 2달에 1개의 게임을 개발하고 글로벌 차트인을
                위해 노력합니다.
              </div>
              <div>
                <div>Hyper-Casual?</div>
                <div>
                  하이퍼 캐주얼은 언어, 문화, 성별 및 나이에 상관없이 누구나
                  쉽게 즐길 수 있는 게임입니다. 복잡한 룰이나 UX는 최대한
                  배제하고, 간단하게 게임을 구성하는 것이 중요합니다. 언뜻 보면
                  다소 시시하다고 느낄 수 있지만, 유저의 데이터를 기반으로 R
                  {"&"}D가 많이 필요한 장르입니다.
                </div>
                <div>
                  국내 시장에선 RPG, Defence 장르의 규모가 큰 게임들이 차트의
                  상위권을 이루고 있지만, 글로벌 차트는 그렇지 않습니다. 미국
                  iOS 인기차트의 경우 50위 권 안에 70% 이상이 하이퍼 캐주얼
                  게임이고, 앞으로 하이퍼 캐주얼 게임 시장의 규모는 더욱 더
                  확대될 것으로 보입니다.
                </div>
                <div>
                  하이퍼 캐주얼 스튜디오팀은 R{"&"}D를 멈추지 않습니다. ‘이
                  부분에서 어떤 이펙트가 연출되어야 유저의 심리에 가장 긍정적인
                  영향을 줄 수 있을까?’, ‘이 게임의 UX가 플레이를 하는
                  유저들에게 어렵진 않을까?’, ‘특정 스테이지의 이탈률이 급격하게
                  늘어나는 이유는 무엇일까?’ 등 게임 제작에서 멈추지 않고 많은
                  고민들을 해결하며 점점 더 넓은 유저층을 확보합니다.
                </div>
                <div>
                  먼데이오프에서는 다소 생소할 수 있는 하이퍼 캐주얼 게임 장르에
                  대해 지속적으로 고민하고, 함께 연구하면서 성장하고 싶은 분들의
                  지원을 기다리고 있습니다.
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "개발" && job?.sort === "Server" ? (
            <>
              <div>
                <div>MondayOFF 퍼블리싱 대시보드 개발팀은 </div>해외 게임
                스튜디오팀과의 연결창구를 마련하는 팀입니다. 우리는 각 국에
                위치한 게임 스튜디오팀과 긴밀한 파트너십을 맺고 교류하며 글로벌
                퍼블리싱 사업을 진행하고 있습니다. 대시보드 개발 팀에서는
                파트너사와의 원활한 협업을 위해 대시보드를 개발하고 유지,
                보수합니다. 트래킹 툴이나 광고 매체에서 제공하는 API를 기반으로
                게임 별 데이터를 수집하고 가공하여 대시보드를 통해 파트너사에게
                보다 좋은 협업 방향을 제시합니다.
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "디자인" && job?.sort === "Game" ? (
            <>
              <div>
                <div>MondayOFF 하이퍼 캐주얼 스튜디오 팀은 </div>누구나 즐길 수
                있는 간단한 게임을 제작하여 MondayOFF 사업 최전방에서 활약하는
                팀입니다. MondayOFF는 국내 최고의 하이퍼 캐주얼 게임 개발사로서
                게임의 제작에 관한 많은 노하우를 가지고 있습니다. 이런 환경에서
                스튜디오 팀은 평균 2달에 1개의 게임을 개발하고 글로벌 차트인을
                위해 노력합니다.
              </div>
              <div>
                <div>Hyper-Casual?</div>
                <div>
                  하이퍼 캐주얼은 언어, 문화, 성별 및 나이에 상관없이 누구나
                  쉽게 즐길 수 있는 게임입니다. 복잡한 룰이나 UX는 최대한
                  배제하고, 간단하게 게임을 구성하는 것이 중요합니다. 언뜻 보면
                  다소 시시하다고 느낄 수 있지만, 유저의 데이터를 기반으로 R
                  {"&"}D가 많이 필요한 장르입니다.
                </div>
                <div>
                  국내 시장에선 RPG, Defence 장르의 규모가 큰 게임들이 차트의
                  상위권을 이루고 있지만, 글로벌 차트는 그렇지 않습니다. 미국
                  iOS 인기차트의 경우 50위 권 안에 70% 이상이 하이퍼 캐주얼
                  게임이고, 앞으로 하이퍼 캐주얼 게임 시장의 규모는 더욱 더
                  확대될 것으로 보입니다.
                </div>
                <div>
                  하이퍼 캐주얼 스튜디오팀은 R{"&"}D를 멈추지 않습니다. ‘이
                  부분에서 어떤 이펙트가 연출되어야 유저의 심리에 가장 긍정적인
                  영향을 줄 수 있을까?’, ‘이 게임의 UX가 플레이를 하는
                  유저들에게 어렵진 않을까?’, ‘특정 스테이지의 이탈률이 급격하게
                  늘어나는 이유는 무엇일까?’ 등 게임 제작에서 멈추지 않고 많은
                  고민들을 해결하며 점점 더 넓은 유저층을 확보합니다.
                </div>
                <div>
                  먼데이오프에서는 다소 생소할 수 있는 하이퍼 캐주얼 게임 장르에
                  대해 지속적으로 고민하고, 함께 연구하면서 성장하고 싶은 분들의
                  지원을 기다리고 있습니다.
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "사업/마케팅" &&
          job?.sort === "Publishing" &&
          job?.lo === "en" ? (
            <>
              <div>
                <div>MondayOFF, Hypercasual Lead in East Asia </div>MondayOFF is
                East Asia’s leading studio and publisher in the field of the
                mobile game genre Hyper Casual. With tons of experience
                developing in-house games and publishing games with our partners
                from around the world, we strive to become one of the top global
                mobile game publishers. Since our foundation in 2018, we’ve
                grown to become a team of over 25 developers, designers and
                publishing managers. We are looking for new talent to bring out
                the most creative games in the market that are fun and keep
                players engaged for a long time.
              </div>
              <div>
                <div>What are hypercasual games?</div>
                <div>
                  Hypercasual games are enjoyed by players worldwide, no matter
                  their language, cultural background, age or gender. Simple
                  rules and design that can be understood within 3 seconds make
                  hypercasual games different from other mobile games on the
                  market.
                </div>
                <div>
                  Korea’s leading mobile game genres tend to be RPG and defense,
                  differing strongly from the international market. Over 70% of
                  the US iOS Game Top 50 are hypercasual games and numbers are
                  rising steadily.
                </div>
                <div>
                  Studios developing hypercasual games have to go beyond simple
                  R{"&"}D. “What effect will bring the most satisfaction to the
                  player at this instance?” “Is the UX too complicated for the
                  players?” “Why do players quit playing at certain stages of
                  the game?” are questions we constantly have to answer in order
                  to reach a wide audience.
                </div>
                <div>
                  At MondayOFF, we are looking for creative people that will try
                  to find the answers and grow with us.
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {job?.position === "디자인" && job?.sort === "Graphic" ? (
            <>
              <div>
                <div>그래픽 콘텐츠 디자이너는 </div>MondayOFF를 세상에 보여주기
                위한 첫 모습을 디자인합니다. 작게는 소셜 네트워크 속 하나의
                게시글부터 시작해 우리의 홈페이지와 내/외부적으로 진행되는
                이벤트의 비주얼 요소를 작업하기도 하고 더 나아가 브랜드
                아이덴티티를 만들 수도 있습니다. 단순한 콘텐츠 제작을 넘어서
                유저들에게 MondayOFF를 더 재미있고 인상적으로 알릴 수 있는
                방향을 탐구합니다.
              </div>
            </>
          ) : (
            ""
          )}
          {job?.position === "사업/마케팅" &&
            job?.sort === "Marketing" &&
            job?.lo === "en" && (
              <>
                <div>
                  <div>MondayOFF, Hypercasual Lead in East Asia </div>MondayOFF
                  is East Asia’s leading studio and publisher in the field of
                  the mobile game genre Hyper Casual. With tons of experience
                  developing in-house games and publishing games with our
                  partners from around the world, we strive to become one of the
                  top global mobile game publishers. Since our foundation in
                  2018, we’ve grown to become a team of over 25 developers,
                  designers and publishing managers. We are looking for new
                  talent to bring out the most creative games in the market that
                  are fun and keep players engaged for a long time.
                </div>
                <div>
                  <div>What are hypercasual games?</div>
                  <div>
                    Hypercasual games are enjoyed by players worldwide, no
                    matter their language, cultural background, age or gender.
                    Simple rules and design that can be understood within 3
                    seconds make hypercasual games different from other mobile
                    games on the market.
                  </div>
                  <div>
                    Korea’s leading mobile game genres tend to be RPG and
                    defense, differing strongly from the international market.
                    Over 70% of the US iOS Game Top 50 are hypercasual games and
                    numbers are rising steadily.
                  </div>
                  <div>
                    Studios developing hypercasual games have to go beyond
                    simple R{"&"}D. “What effect will bring the most
                    satisfaction to the player at this instance?” “Is the UX too
                    complicated for the players?” “Why do players quit playing
                    at certain stages of the game?” are questions we constantly
                    have to answer in order to reach a wide audience.
                  </div>
                  <div>
                    At MondayOFF, we are looking for creative people that will
                    try to find the answers and grow with us.
                  </div>
                  <div>Market Growth Team of MondayOFF</div>
                  <div>
                    As a Monetization Manager, you will be part of the Market
                    Growth Team of MondayOFF. MondayOFF has top class
                    experiences especially in User Acquisition and Monetization.
                    Each member will deal with at least $10M of revenue or UA
                    budget per year. You also are able to access substantial
                    information about Monetization {"&"} UA strategy for being a
                    global top publisher. MondayOFF wants only a few highly
                    talented colleagues to communicate with international teams.
                  </div>
                </div>
              </>
            )}
          {job?.position === "사업/마케팅" && job?.sort === "Creative" ? (
            <>
              <div>
                <div>MondayOFF Creative팀은 </div>먼데이오프에서 출시한 하이퍼
                캐주얼 게임들의 날개를 달아주는 팀입니다. 출시하는 게임들의 홍보
                영상을 제작하고, 유저의 반응을 분석하여, 보다 좋은 결과를 도출할
                수 있도록 항상 고민합니다. 영상편집 직무에 국한되기보단,
                데이터를 분석하고 어떤 영상을 제작할지 창의적으로 생각하여
                업무를 진행합니다.
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div
          className={classNames(!isDarkMode ? styles.line : styles.dark_line)}
        ></div>
        <div
          className={classNames(
            !isDarkMode ? styles.applyDetail : styles.dark_applyDetail
          )}
        >
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Description" : "담당업무"}
            </div>
            {job?.RS[0]?.contents ? (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
              >
                <div>
                  {job?.RS[0]?.contents?.map((c, i) => (
                    <div key={i}>{c}</div>
                  ))}
                </div>
                <br />
                <div>
                  {job?.RS[1]?.contents?.map((c, i) => (
                    <div key={i}>{c}</div>
                  ))}
                </div>
              </div>
            ) : (
              job?.RS?.map((d, i) => (
                <div
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                  key={i}
                >
                  • {d}
                </div>
              ))
            )}
          </div>

          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Qualifications" : "지원자격"}
            </div>
            {job?.lo === "en" && (
              <>
                <div
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                  style={{ textDecoration: "underline", fontWeight: "bold" }}
                >
                  • Visa holders: E-7, F-2, F-4, F-5, F-6, D-10, D-2 (possible
                  to sponsor by company)
                </div>
                <div
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                  style={{ textDecoration: "underline", fontWeight: "bold" }}
                >
                  • Full - Time worker
                </div>
                <div
                  className={classNames(
                    !isDarkMode
                      ? styles.detailContext
                      : styles.dark_detailContext
                  )}
                  style={{ textDecoration: "underline", fontWeight: "bold" }}
                >
                  • Must Reside in Korea
                </div>
              </>
            )}

            {job?.MQ?.map((d, i) => (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
                key={i}
              >
                • {d}
              </div>
            ))}
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Preferences" : "우대조건"}
            </div>
            {job?.PQ?.map((d, i) => (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
                key={i}
              >
                • {d}
              </div>
            ))}
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Basic Requirement" : "공통 지원자격"}
            </div>

            <div
              className={classNames(
                !isDarkMode ? styles.detailContext : styles.dark_detailContext
              )}
            >
              •{" "}
              {job?.lo === "en"
                ? "Must be able to travel abroad"
                : "해외 여행에 결격 사유가 없으신 분"}
            </div>
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Required Documents" : "제출 서류 및 방법"}{" "}
              <span>
                *{" "}
                {job?.lo === "en"
                  ? "All documents should be uploaded as a PDF file."
                  : "제출 서류 모두 PDF파일로 제출"}
              </span>
            </div>

            {job?.DC?.map((d, i) => (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
                key={i}
              >
                • {d}
              </div>
            ))}
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Application Process" : "채용절차"}
            </div>
            {job?.OHP?.map((d, i) => (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
                key={i}
              >
                • {d}
                <br />
                {job?.lo === "en" && "* Duration may be subject to change"}
              </div>
            ))}
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Working Conditions" : "근무 조건"}
            </div>

            <div
              className={classNames(
                !isDarkMode ? styles.detailContext : styles.dark_detailContext
              )}
            >
              • {job.form}
            </div>

            <div
              className={classNames(
                !isDarkMode ? styles.detailContext : styles.dark_detailContext
              )}
            >
              •{" "}
              {job?.lo === "en"
                ? "Work Hours : 09:00 - 17:00, Mon-Fri (Work Hours Flexible)"
                : "근무 시간 : 주 5일 (월요일 ~ 금요일 근무, 일일 근로시간 7시간)"}
            </div>
            {!job?.lo && (
              <div
                className={classNames(
                  !isDarkMode ? styles.detailContext : styles.dark_detailContext
                )}
              >
                • 급여 조건 : 회사 내규에 따름
              </div>
            )}

            <div
              className={classNames(
                !isDarkMode ? styles.detailContext : styles.dark_detailContext
              )}
            >
              •{" "}
              {job?.lo === "en"
                ? "Location : Seoul, Gangnam-gu. 3 minute walk from Seonjeongneung Station (Line 9/Suin-Bundang Line)"
                : "근무지 : 서울 강남구 9호선/수인분당선 선정릉역 도보 3분 이내"}
            </div>
          </div>
          <div>
            <div
              className={classNames(
                !isDarkMode ? styles.detailTitle : styles.dark_detailTitle
              )}
            >
              {job?.lo === "en" ? "Additional Information" : "기타 사항"}
            </div>

            <div
              className={classNames(
                !isDarkMode ? styles.detailContext : styles.dark_detailContext
              )}
            >
              •{" "}
              {job?.lo === "en"
                ? "False information on job applications may lead to the withdrawal of the job offer even after successful admission"
                : "  입사 지원 서류에 허위사실이 발견될 경우, 채용확정 이후라도 입사가 취소될 수 있습니다."}
            </div>
          </div>
        </div>
        <div
          className={classNames(
            !isDarkMode ? styles.btnContainer : styles.dark_btnContainer
          )}
        >
          <Link to="/position/apply" state={{ data: job }}>
            <button className={styles.applyBtn}>
              {job?.lo === "en" ? "Apply now" : "지원하기"}
            </button>
          </Link>
        </div>
        <Link
          to="/position"
          className={classNames(
            !isDarkMode ? styles.backBtn : styles.dark_backBtn
          )}
        >
          <img
            src={!isDarkMode ? arrow : darkArrow}
            alt=""
            className={classNames(
              !isDarkMode ? styles.arrow : styles.dark_arrow
            )}
          />
          <div>{job?.lo === "en" ? "Back" : "목록으로"}</div>
        </Link>
      </>
    </div>
  );
};

export default JobDetail;
